import React from "react";
import axios from "axios";
import { Component } from "react";
import { Button } from "@sketchpixy/rubix";

export class ConfirmDoctorLicense extends Component {
  constructor(props) {
    super(props);

    let currentDbq =
      this.props.location && this.props.location.currentDbq
        ? this.props.location.currentDbq
        : JSON.parse(sessionStorage.getItem("currentDbq"));

    let patient =
      this.props.location && this.props.location.patient
        ? this.props.location.patient
        : JSON.parse(sessionStorage.getItem("patient"));
    let questionState =
      this.props.location && this.props.location.questionState
        ? this.props.location.questionState
        : JSON.parse(sessionStorage.getItem("questionState"));

    this.chooseLicense = this.chooseLicense.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.goToPreviousPage = this.goToPreviousPage.bind(this);

    this.state = {
      licensesArrayFromProviderModule: [],
      apptLicense: "",
      apptState: "",
      currentDbq: currentDbq,
      patient: patient,
      questions: questionState,
      current: 0,
      isLicenseReadOnly: true,
      portabilityActStates: [
        { name: "Alabama", shortName: "AL" },
        { name: "Arizona", shortName: "AZ" },
        { name: "Arkansas", shortName: "AR" },
        { name: "Colorado", shortName: "CO" },
        { name: "Connecticut", shortName: "CT" },
        { name: "Delaware", shortName: "DE" },
        { name: "DC", shortName: "DC" },
        { name: "Georgia", shortName: "GA" },
        { name: "Idaho", shortName: "ID" },
        { name: "Illinois", shortName: "IL" },
        { name: "Indiana", shortName: "IN" },
        { name: "Kansas", shortName: "KS" },
        { name: "Kentucky", shortName: "KY" },
        { name: "Maine", shortName: "ME" },
        { name: "Maryland", shortName: "MD" },
        { name: "Michigan", shortName: "MI" },
        { name: "Minnesota", shortName: "MN" },
        { name: "Missouri", shortName: "MO" },
        { name: "Nebraska", shortName: "NE" },
        { name: "Nevada", shortName: "NV" },
        { name: "New Hampshire", shortName: "NH" },
        { name: "New Jersey", shortName: "NJ" },
        { name: "North Carolina", shortName: "NC" },
        { name: "Ohio", shortName: "OH" },
        { name: "Oklahoma", shortName: "OK" },
        { name: "Pennsylvania", shortName: "PA" },
        { name: "Tennessee", shortName: "TN" },
        { name: "Texas", shortName: "TX" },
        { name: "Utah", shortName: "UT" },
        { name: "Virginia", shortName: "VA" },
        { name: "Washington", shortName: "WA" },
        { name: "West Virginia", shortName: "WV" },
        { name: "Wisconsin", shortName: "WI" },
        { name: "Wyoming", shortName: "WY" },
      ],
    };
  }

  componentDidMount() {
    try {
      const patientLocalStorage = sessionStorage.getItem("patient")
        ? JSON.parse(sessionStorage.getItem("patient"))
        : null;

      const token = localStorage.getItem("login_token");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      // get the state associated with the appointment
      axios
        .post(
          `${process.env.API_URL}/dbq/get-appt-info`,
          {
            apptId: patientLocalStorage.apptId,
          },
          { headers }
        )
        .then((response) => {
          // if exam type is telehealth and it is either a mental or ptsd, show license dropdown
          // we allow doctors to select license of different state if the above conditions are met
          if (
            response.data.examType === "telehealth" &&
            this.state.portabilityActStates.find(
              (state) =>
                state.name === response.data.apptState ||
                state.shortName === response.data.apptState
            ) &&
            (this.state.currentDbq.name_fv.toLowerCase().includes("mental") ||
              this.state.currentDbq.name_fv.toLowerCase().includes("ptsd"))
          ) {
            this.setState({
              apptState: response.data.apptState,
              isLicenseReadOnly: false,
              apptLicense: response.data.apptLicense,
            });
          } else {
            this.setState({
              apptState: response.data.apptState,
              isLicenseReadOnly: true,
              apptLicense: response.data.apptLicense,
            });
          }
        })
        .catch((e) => {
          this.setState({
            apptState: "",
            isLicenseReadOnly: true,
            apptLicense: patientLocalStorage.doctorsInfo.licenseNo,
          });
        });

      // get doctor license from account, not from appt
      axios
        .post(
          `${process.env.API_URL}/dbq/get-doctor-licenses`,
          {
            providerId: localStorage.getItem("providerId"),
            doctorNpi: patientLocalStorage.doctorsInfo.npi,
            apptId: patientLocalStorage.apptId,
            disabilityId: patientLocalStorage.disabilities[0].dbqId,
          },
          { headers }
        )
        .then((response) => {
          const licensesArrayFromProviderModule = response.data.doctorLicenses
            .replace(/ /g, "")
            .split(",")
            .filter((license) => {
              if (
                this.state.portabilityActStates.find(
                  (state) =>
                    state.name === license.substring(0, 2) ||
                    state.shortName === license.substring(0, 2)
                )
              ) {
                return true;
              } else {
                return false;
              }
            })
            .sort((license, nextLicense) => {
              if (license !== null && nextLicense !== null) {
                if (license.toLowerCase() < nextLicense.toLowerCase()) {
                  return -1;
                } else if (license.toLowerCase() > nextLicense.toLowerCase()) {
                  return 1;
                }
              }
              return 0;
            });

          this.setState({
            licensesArrayFromProviderModule: licensesArrayFromProviderModule,
          });
        })
        .catch((e) => {
          console.log(e)
          this.setState({
            licensesArrayFromProviderModule: [],
          });
        });
    } catch (e) {
      this.props.history.goBack();
    }
  }

  chooseLicense(e) {
    this.setState({ apptLicense: e.target.value });
  }

  goToNextPage() {
    sessionStorage.setItem("selectedLicense", this.state.apptLicense)
    this.props.history.push({
      pathname: "/admin/review",
      currentDbq: this.state.currentDbq,
      patient: this.state.patient,
      questionState: this.state.questions,
      selectedLicense: this.state.apptLicense,
    });
  }

  goToPreviousPage() {
    this.props.history.push({
      pathname: "/admin/exam",
      current: this.state.questions.length-1,
      currentDbq: this.state.currentDbq,
      patient: this.state.patient,
      questionState: this.state.questions,
    });
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1 style={{ color: "black" }}>
            <strong>
              The state license that will be placed on the DBQ is below.
            </strong>
          </h1>
          <h2>
            <strong>Please confirm (</strong>
            or if available, select another valid license<strong>
              ).
            </strong>{" "}
          </h2>
          <br />
          <div
            style={{
              border: "1.5px solid black",
              padding: "10px 10px 5rem 10px",
              margin: "6rem",
            }}
          >
            {this.state.apptState === "" ? (
              <h3>Loading license information...</h3>
            ) : (
              <div>
                <h3 style={{ color: "black" }}>
                  <strong>Clinic State: {this.state.apptState}</strong>
                </h3>
                <h3 style={{ color: "black" }}>
                  <strong>State License:</strong>
                </h3>

                {this.state.licensesArrayFromProviderModule.length === 0 ||
                this.state.isLicenseReadOnly === true ? (
                  <h3 style={{ color: "black" }}>{this.state.apptLicense}</h3>
                ) : (
                  <select
                    value={this.state.apptLicense}
                    onChange={this.chooseLicense}
                    style={{ width: "25rem", padding: "10px", color: "black" }}
                    title="Select license"
                  >
                    {this.state.licensesArrayFromProviderModule.map(
                      (license) => (
                        <option style={{ padding: "6px" }} value={license}>
                          {license}
                        </option>
                      )
                    )}
                  </select>
                )}
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              lg
              type="button"
              bsStyle="primary"
              className="back-btn big-btn"
              onClick={this.goToPreviousPage}
            >
              <span className="backiconspan">
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z"
                    fill="#797979"
                  />
                </svg>
              </span>
              Back
            </Button>
            <Button
              lg
              type="button"
              bsStyle="primary"
              className="next-btn big-btn"
              onClick={this.goToNextPage}
            >
              Next{" "}
              <span className="nexticonspan arrow-animate">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </Button>{" "}
          </div>
        </div>
      </div>
    );
  }
}
